module.exports = __webpack_public_path__ + "static/media/jobfair2.987031b6.jpg";